<template>
  <VDialog
    @click:outside="close"
    class="user_modal_dialog"
    max-width="550px"
    persistent
    v-model="value"
    v-if="item"
  >
    <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
      <form @submit.prevent="handleSubmit(apply)">
        <VCard>
          <VCardTitle>
            <span class="headline title_modal_user">{{
              hasProductCount > 0 ? $t("givePartiallyProduct") : $t("noProduct")
            }}</span>
            <v-icon @click="close" class="info_modal_close">mdi-close</v-icon>
          </VCardTitle>
          <VCardText class="main_modal pb-4">
            <div class="d-flex mb-2">
              <span class="mr-4 text--accent-1 primary--text"
                >{{ $t("available") }}
                <span class="font-weight-bold">
                  {{ item["hasProductCount"] }}
                </span>
              </span>
              <span class="accent-1 primary--text"
                >{{ $t("asked") }}
                <span
                  :class="['font-weight-bold', { 'error--text': askedALotOf }]"
                >
                  {{ item["count"] }}
                  {{
                    item[`unit_type_name_${$i18n.locale}`] &&
                    item[`unit_type_name_${$i18n.locale}`].toLowerCase()
                  }}</span
                ></span
              >
            </div>
            <div class="d-flex mx-n2">
              <div class="d-flex px-2" v-if="hasProductCount">
                <span
                  class="text--accent-1 mt-5 mr-2 blue-dark--text flex-shrink-0"
                  >{{ $t("giveOut") }}</span
                >
                <CustomInputText
                  min="0"
                  type="number"
                  :name="$t('giveOut')"
                  v-model="provideProductCount"
                  :rules="provideProductCountRule"
                  class="pa-0 user_input flex-grow-1"
                ></CustomInputText>
              </div>
              <div class="d-flex px-2">
                <span
                  class="text--accent-1 mt-5 mr-2 blue-dark--text flex-shrink-0"
                  >{{ $t("tender") }}</span
                >
                <CustomInputText
                  min="0"
                  :name="$t('tender')"
                  type="number"
                  v-model="contractProductCount"
                  :rules="contractProductCountRule"
                  class="pa-0 user_input flex-grow-1"
                ></CustomInputText>
              </div>
            </div>
            <div v-if="isSubmitted && isRejectedOrderItem">
              <span class="error--text">{{
                $t("doYouWantReject", { count: rejectProductCount })
              }}</span>
              <div class="user_input">
                <CustomTextTextarea
                  :name="$t('reasonRejectContract')"
                  rules="required"
                  v-model="rejectFormData.reason"
                ></CustomTextTextarea>
              </div>
              <div class="file_input_modal_add_ozl">
                <ValidationProvider
                  :name="$t('file')"
                  rules="required|document|not_empty_file"
                  v-slot="{ errors }"
                >
                  <VFileInput
                    :label="$t('attachFile') + '*'"
                    v-model="rejectFormData.file"
                    :error-messages="errors[0]"
                  ></VFileInput>
                </ValidationProvider>
              </div>
            </div>
            <div class="pt-2">
              <VBtn class="w_100" type="submit" color="primary" dark>{{
                $t(hasProductCount > 0 ? "approve" : "send")
              }}</VBtn>
            </div>
          </VCardText>
        </VCard>
      </form>
    </ValidationObserver>
  </VDialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      isSubmitted: false,
      provideProductCount: "0",
      contractProductCount: "0",
      rejectFormData: {
        reason: "",
        file: null,
      },
    };
  },
  methods: {
    apply() {
      if (!this.isRejectedOrderItem || this.isSubmitted) {
        const value = {
          orderItemId: this.item.id,
          provideProductCount: this.provideProductCount,
          rejectProductCount: this.rejectProductCount,
          contractProductCount: this.contractProductCount,
        };
        if (this.rejectFormData.file) {
          value.file = this.rejectFormData.file;
          value.reason = this.rejectFormData.reason;
        }
        this.$emit("apply", value);
      }
      this.isSubmitted = true;
    },
    close() {
      this.$emit("input", false);
    },
  },
  watch: {
    value(val) {
      if (!val) {
        const { formObs } = this.$refs;
        this.provideProductCount = "0";
        this.contractProductCount = "0";
        this.isSubmitted = false;
        this.rejectFormData = {
          reason: "",
          file: null,
        };
        if (formObs) formObs.reset();
      }
    },
  },
  computed: {
    provideProductCountRule() {
      let max_value =
        this.hasProductCount - this.productCount > 0
          ? this.productCount
          : this.hasProductCount;
      return {
        required: true,
        max_given_value: max_value,
      };
    },
    productCount() {
      let count = parseFloat(this.item.count);
      return Number.isNaN(count) ? 0 : count;
    },
    hasProductCount() {
      let count = parseFloat(this.item["hasProductCount"]);
      return Number.isNaN(count) ? 0 : count;
    },
    contractProductCountRule() {
      return {
        required: true,
        min_value: 0,
        max_given_value:
          this.provideProductCount &&
          this.productCount - parseFloat(this.provideProductCount) > 0
            ? this.productCount - parseFloat(this.provideProductCount)
            : false,
      };
    },
    rejectProductCount() {
      const difference =
        parseFloat(this.item.count) -
        parseFloat(this.contractProductCount) -
        parseFloat(this.provideProductCount);
      return difference > 0 ? `${difference}` : "0";
    },
    isRejectedOrderItem() {
      return parseFloat(this.rejectProductCount) > 0;
    },
    askedALotOf() {
      if (this.item) {
        return (
          parseFloat(this.item["hasProductCount"]) -
            parseFloat(this.item.count) <=
          0
        );
      }
      return false;
    },
  },
};
</script>
